import each from 'lodash/each';
import isArray from 'lodash/isArray';
import size from 'lodash/size';
import {window} from 'ssr-window';

const pushToLOQ = data => {
    /* eslint-disable no-underscore-dangle */
    if (!window._loq) {
        window._loq = [];
    }

    window._loq.push(['custom', data]);
    /* eslint-enable no-underscore-dangle */
};

/**
 * Utilities for working with Lucky Orange.
 * @module LuckyOrangeUtils
 */
const LuckyOrangeUtils = {
    /**
     * Pushes data to the LOQ array.
     * @static
     * @function push
     * @param {Array.<Object>} data={} - Arbitrary object (or array of objects) to send to the LOQ array.
     * @example
     * LuckyOrangeUtils.push({
     *     name : 'John Doe',
     *     email : 'email@example.com',
     *     whatever1 : 'Anything here'
     * });
     * @returns {void}
     */
    push(data = {}) {
        if (size(data)) {
            if (isArray(data)) {
                each(data, customData => {
                    pushToLOQ(customData);
                });
            } else {
                pushToLOQ(data);
            }
        }
    },
};

export default LuckyOrangeUtils;
